import clsx from "clsx";
import React, { CSSProperties, ReactElement, useState } from "react";

interface Props {
    label: string,
    children: ReactElement
    position: 'bottom' | 'left' | 'bottom-left' | 'top'
    color?: 'blue'
}

export function InfoTextPopup(props: Props) {
    const { label } = props
    const { children } = props
    const { position } = props

    const [hover, setHover] = useState<boolean>(false)

    const positionMap = new Map<'bottom' | 'left' | 'bottom-left' | 'top', CSSProperties>([
        ['bottom', {
            position: "absolute",
            top: "115%",
            width: "auto",
            right: '0px',
            left: '0%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        }],
        ['left', {
            position: "absolute",
            top: '50%',
            bottom: '50%',
            left: '30px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: 'auto'
        }],
        ['bottom-left', {
            position: "absolute",
            top: "115%",
            width: "auto",
            right: '0%',
            left: '0%',
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'flex-end'
        }],
        ['top', {
            position: "absolute",
            bottom: '115%',
            width: "auto",
            right: '0px',
            left: '0%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        }]
    ])

    return (
        <div className={"relative w-full"}>
            {
                hover &&
                <div
                    style={positionMap.get(position)}
                >
                    <div
                        className={clsx("text-text-xs  font-bold text-center  rounded-lg z-[5]",
                            {
                                "bg-neutral-50 text-neutral-500": !props.color ,
                                "bg-brandPrimary-800 text-white": props.color === 'blue'
                            }
                        )}
                        style={{
                            padding: '4px 6px',
                            boxShadow: "0px 1px 2px rgba(34, 36, 47, 0.16)"
                        }}>
                        {label}
                    </div>
                </div>
            }
            <div
                onMouseOver={() => setHover(true)}
                onMouseOut={() => setHover(false)}
                className={"flex items-center"}
            >
                {children}
            </div>
        </div >
    )
}